import React, { useState } from 'react'
//Bibliotecas
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
//Componentes
import Modal from '../../../components/common/Modal';
import Form from '../../../components/common/Form';
import Input from '../../../components/common/Input';
import Success from '../../../components/common/Success';
import Error from '../../../components/common/Error';
import Button from '../../../components/common/Button';
//Servicios
import AuthService from '../../../services/AuthService';
//Imágenes
import { Mail } from 'react-feather';

function PasswordRecover({ recoverModal, setRecoverModal, isPrivate, email}) {
    //Estados
    //const [recoverModal, setRecoverModal] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    //Manipuladores
    const handleCloseModal = () => {
        setRecoverModal(false);
        setSuccess('');
        setError('');
        reset();
    }


    //React Hook Form
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    //Handle Submit
    const onSubmit = (data) => {
        setLoading(true);
        AuthService.recoverPassword(email?{email}:data).then((res) => {
            setSuccess(`Se ha enviado un enlace a ${email?email:data.email} para restablecer la contraseña, por favor revisa tu bandeja de entrada.`);
            setLoading(false);
        }).catch((error) => {
            console.log("entro a error");
            setError(error.message);
            setLoading(false);
        });
        reset();
    }

    return (
        <>
            <Modal state={recoverModal} setState={setRecoverModal} title={isPrivate ? "Cambiar contraseña" : "¿Olvidaste tu contraseña?"} textAlign='left' handleClose={handleCloseModal} >
                {!success &&
                    <Form onSubmit={handleSubmit(onSubmit)} width='100%' padding='16px 32px' boxShadow='none'>
                        {!isPrivate &&
                            <>
                                <Info>Introduce la dirección de correo electrónico que utilizaste cuando te registraste y te enviaremos un enlace para restablecer tu contraseña.</Info>
                                <Input
                                    register={register}
                                    name='email'
                                    required={{ required: "El email es obligatorio" }}
                                    placeholder="Ingresa tu email"
                                    error={errors.email}
                                />
                            </>
                        }
                        {isPrivate &&
                            <>
                                <Info>Se enviará un mensaje al correo electrónico que utilizaste cuando te registraste con un enlace para restablecer tu contraseña.</Info>
                            </>
                        }
                        <Button type='submit' margin='8px 0px 0px 0px ' loading={loading}><Mail />Restablecer contraseña</Button>
                        <Error message={error}></Error>
                    </Form>
                }
                <Success message={success}></Success>
            </Modal>
        </>
    )
}

export default PasswordRecover

const Info = styled.span`
    width:90%;
    margin-bottom:16px;    
`;